import { useState } from 'react';

const faqs = [
  {
    q: '樱花视频平台上的视频都是高清的吗？',
    a: '是的！我们平台上的所有视频均支持高清播放，大部分视频提供1080P甚至4K分辨率。无论您是在电脑、平板还是手机上观看樱花视频，都能获得极致的视觉体验。我们专门优化了樱花延时摄影和慢动作视频的画质，让每一片花瓣都清晰可见。',
  },
  {
    q: '如何下载樱花视频到本地保存？',
    a: '目前樱花视频平台支持在线高清播放和收藏功能。您可以将喜欢的樱花视频添加到个人收藏夹中，随时随地在线观看。下载功能正在开发中，敬请期待。成为会员后可享受离线缓存功能，即使没有网络也能欣赏最美樱花。',
  },
  {
    q: '日本樱花视频的拍摄地点有哪些？',
    a: '我们的日本樱花视频涵盖了从南到北的经典赏樱名所，包括东京上野公园、目黑川、京都岚山、哲学之道、奈良吉野山、大阪造币局、北海道五棱郭等数十个地点。每个视频都标注了具体的拍摄地点和时间，方便您规划赏樱行程。',
  },
  {
    q: '樱花一般在什么时候盛开？',
    a: '樱花花期因品种和地理位置不同而有很大差异。日本南部的冲绳1月下旬就开始开花，而北部的北海道要等到5月上旬。中国国内的樱花一般在3月到4月盛开。建议关注我们的"赏樱攻略"栏目，每年都会更新最新的樱花前线预测和各地点最佳观赏时间。',
  },
  {
    q: '我可以投稿自己的樱花视频吗？',
    a: '非常欢迎！我们一直在寻找优质的樱花视频内容。如果您有自己拍摄的樱花视频、延时摄影或赏樱Vlog，可以通过"关于我们"页面的联系方式与我们取得联系。投稿一经采用，我们将提供首页推荐位和相应的稿酬奖励。',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            关于樱花视频，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-xl border border-background-200/70 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left"
              >
                <span className="text-sm font-medium text-foreground-950 pr-4">
                  {faq.q}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-300 ${
                    openIndex === i ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}